import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import CallToActionButton from '../../../component/call-to-action-button/call-to-action-button';
import { PaymentServiceWithVersionsResponseType } from '../../../api/types/payments/payment-template';
import { EditTextDialog } from '../../settings/componenets/edit-entity-name-dialog/edit-text-dialog';
import { AddPaymentServiceDialog } from './componenets/add-payment-service-dialog';
import { PaymentServicesTable } from './componenets/payment-services-table';
import { deletePaymentServiceOperation } from './operations/delete-payment-service.operation';
import { editPaymentServiceNameOperation } from './operations/edit-payment-service-name.operation';

export const PaymentPageTabs = observer(() => {
  const [refreshKey, setRefreshKey] = useState<number>(0);

  const [addPaymentDialog, setAddPaymentDialog] = useState(false);
  const [editPaymentService, setEditPaymentService] =
    useState<PaymentServiceWithVersionsResponseType | null>(null);
  const [editLoading, setEditLoading] = useState(false);
  const [deletePaymentServiceId, setDeletePaymentServiceId] = useState<
    number | null
  >(null);

  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  const closeDialog = () => {
    setAddPaymentDialog(false);
    triggerRefresh();
  };

  const handleEditPaymentService = (
    paymentService: PaymentServiceWithVersionsResponseType,
  ) => {
    setEditPaymentService(paymentService);
  };

  const handleSavePaymentService = async (id: number, newName: string) => {
    await editPaymentServiceNameOperation(id, newName, setEditLoading);
    setEditPaymentService(null);
    triggerRefresh();
  };

  const handleDeletePaymentService = async (
    rowData: PaymentServiceWithVersionsResponseType,
  ) => {
    await deletePaymentServiceOperation(rowData.id, setDeletePaymentServiceId);
    triggerRefresh();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <EditTextDialog
        id={editPaymentService?.id}
        value={editPaymentService?.paymentServiceName}
        title="עריכת שרות תשלום"
        label="שם שרות התשלום"
        loading={editLoading}
        onSave={handleSavePaymentService}
        onHide={() => setEditPaymentService(null)}
      />

      <div
        style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
      >
        <CallToActionButton
          text={'הוספה'}
          onClick={() => {
            setAddPaymentDialog(true);
          }}
        />
      </div>

      <PaymentServicesTable
        onEditRow={handleEditPaymentService}
        onDeleteRow={handleDeletePaymentService}
        deleteLoadingForId={deletePaymentServiceId}
        refreshKey={refreshKey}
      />

      <Dialog
        header="הוספת שרות תשלומים"
        visible={addPaymentDialog}
        style={{
          width: '800px',
          height: '70vh',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setAddPaymentDialog(false);
        }}
      >
        <AddPaymentServiceDialog closeDialog={closeDialog} />
      </Dialog>
    </div>
  );
});
